<template>
  <div>
    <div style="margin-right: 20px">
     <span :class="[isMobile ? 'amount' : '']" style="padding-left: 20px;"> موجودی کیف پول شما: {{ currentCharge }} ریال </span>
      <app-history
        @clicked="
          showChargeDialog = true;
          amount = 100000;
        "
        title="شارژ کیف پول"
        :fixsize="true"
      />
      <app-history
        @clicked="showSearchDialog = true"
        class="advancedSearch"
        title="جستجوی پیشرفته"
      />
    </div>

    <div>
      <v-data-table
        :items="payments"
        :server-items-length="totalCount"
        :headers="paymentsHeaders"
        class="elevation-1 rounded"
        :footer-props="{
          itemsPerPageAllText: 'همه',
          itemsPerPageText: 'تعداد ردیف',
          itemsPerPageOptions: [10],
        }"
        :no-data-text="tableText"
        :header-props="$store.getters.headerProps"
        @pagination="doPage"
      >
        <template v-slot:[`item.paymentType`]="{ item }">
          {{ item.paymentType == 1 ? "ثبت دستی" : "پرداخت اینترنتی" }}
        </template>
        <template v-slot:[`item.date`]="{ item }">
          {{ convertDate(item.date) }}
        </template>
        <template v-slot:[`item.amount`]="{ item }">
          {{ Number(item.amount).toLocaleString() }}
        </template>
        <template v-slot:[`footer.page-text`]="{ pageStart, pageStop }">
          از {{ pageStart }} تا {{ pageStop }}
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="showChargeDialog" content-class="myDialog">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> مبلغ(ریال)</v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            v-model="amount"
            maxlength="12"
            :oninput="onInput"
            class="textLtr"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="ltr">
        <v-btn
          color="green white--text"
          class="dialogButton"
          rounded
          @click="applyRequest"
          :disabled="apiRunning"
        >
          پرداخت
        </v-btn>
        <v-btn class="dialogButton" rounded @click="showChargeDialog = false">
          انصراف
        </v-btn>
      </v-row>
    </v-dialog>
    <v-dialog v-model="showSearchDialog" content-class="myDialog">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> تاریخ شروع: </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            :value="StartDate"
            @click="onClickDate(1)"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> تاریخ پایان: </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            :value="EndDate"
            @click="onClickDate(2)"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="ltr">
        <v-btn
          color="green white--text"
          class="dialogButton"
          rounded
          @click="GetUserPayments"
          :disabled="apiRunning"
        >
          جستجو
        </v-btn>
        <v-btn
          color="red white--text"
          class="dialogButton"
          rounded
          @click="clearFilter"
          :disabled="apiRunning"
        >
          پاک کردن
        </v-btn>
        <v-btn class="dialogButton" rounded @click="showSearchDialog = false">
          انصراف
        </v-btn>
      </v-row>
    </v-dialog>
    <date-picker
      ref="datepicker1"
      v-model="StartDate"
      :editable="false"
      :auto-submit="true"
      element="fileInput1"
      @change="onChangeDate($event, 1)"
    ></date-picker>
    <input id="fileInput1" ref="fileInput1" />
    <date-picker
      ref="datepicker2"
      v-model="EndDate"
      :editable="false"
      :auto-submit="true"
      element="fileInput2"
      @change="onChangeDate($event, 2)"
    ></date-picker>
    <input id="fileInput2" ref="fileInput2" />
  </div>
</template>

<script>
import Vue from "vue";
import HistoryButton from "@/components/HistoryButton";
import Dialog from "@/components/Dialog";
import { GetUserPayments, StartPayment, CalculateCredit } from "@/api/payments";
import moment from "moment-jalaali";
export default {
  components: {
    appHistory: HistoryButton,
    appDialog: Dialog,
  },
  data() {
    return {
      showChargeDialog: false,
      showSearchDialog: false,
      payments: [],

      currentCharge: 0,

      amount: 0,
      StartDate: "",
      EndDate: "",
      paymentsHeaders: [
        {
          text: "شناسه",
          value: "id",
          width: "10%",
        },
        {
          text: "مبلغ(ریال)",
          value: "amount",
          width: "10%",
          cellClass: "cellLtr",
        },
        {
          text: "نوع",
          value: "paymentType",
          width: "10%",
        },
        {
          text: "تاریخ",
          value: "date",
          width: "20%",
          cellClass: "cellLtr",
        },
      ],
      totalCount: 0,
    };
  },
  created() {
    if (this.currentRole) {
      this.CalculateCredit();
      this.GetUserPayments();
    }
  },
  computed: {
    tableText() {
      return this.$store.getters.tableText;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
    currentRole() {
      return this.$store.getters.currentRole;
    },
    onInput() {
      return "this.value=this.value.slice(0,this.maxLength)";
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
  watch: {
    amount: function (newValue) {
      const result = newValue
        .toString()
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      Vue.nextTick(() => (this.amount = result));
    },
  },
  methods: {
    GetUserPayments(skip) {
      if (isNaN(skip)) skip = 0;
      this.$store.commit("SET_TABLE_TEXT", true);
      return new Promise((resolve, reject) => {
        GetUserPayments(
          this.currentRole.BranchID,
          this.StartDate,
          this.EndDate,
          skip
        )
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.payments = response.data.items;
            this.totalCount = response.data.count;
            this.$store.commit("SET_TABLE_TEXT", false);
            this.showSearchDialog = false;
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onChangeDate($event, input) {
      if (input == 1) {
        this.StartDate = $event.format("jYYYY/jMM/jDD");
      } else {
        this.EndDate = $event.format("jYYYY/jMM/jDD");
      }
    },
    onClickDate(input) {
      if (input == 1) {
        this.$refs.fileInput1.click();
      } else {
        this.$refs.fileInput2.click();
      }
    },
    clearFilter() {
      this.StartDate = "";
      this.EndDate = "";
      this.GetUserPayments();
    },
    doPage($event) {
      this.GetUserPayments(($event.page - 1) * 10);
    },
    CalculateCredit() {
      return new Promise((resolve, reject) => {
        CalculateCredit(this.currentRole.BranchID)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.currentCharge = response.data;

            this.$store.commit("SET_TABLE_TEXT", false);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    convertDate(date) {
      return moment(date).format("jYYYY/jMM/jDD HH:mm");
    },

    applyRequest() {
      var text = "";
      this.amount = this.amount.replace(/,/g, "");
      const amount = parseInt(this.amount);
      if (isNaN(amount) || amount <= 0 || amount != this.amount) {
        text = "مبلغ بابستی یک عدد صحیح مثبت باشد";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        //this.$store.commit("SET_API_RUNNING", true);
        this.showChargeDialog = false;
        StartPayment(
          this.currentRole.BranchID,

          this.amount
        )
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.message);
            this.$store.commit("SET_API_RUNNING", false);

            if (data.data) {
              setTimeout(function () {
                window.location.href = data.data.paymentUrl;
              }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },
  },
};
</script>
<style >
.text-start.cellLtr {
  direction: ltr;
  text-align: end !important;
}

.textLtr input {
  direction: ltr;
  text-align: right;
}
.amount {
  display: block;
  width: 100%;
  margin-top: 20px;
}
</style>
